/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import "./m.css"
export default function Timelinie() {

    return (
      
        <div className = "container-fluid"  style={{ backgroundColor : 'black' }}>
            <div className = "container" style={{ padding: 30 }}>
            <br /> <br />
                <h1 className="what-i-do text-center" style = {{color : "white"}}> ABOUT ME </h1>
                <br /> <br /> <br />
                <div className = "table">

                    <tbody className="codeLineNumber">
                        <tr>
                            <td> <a style={{ color: '#636D83' }} >01</a></td>
                            <td > <a style={{ color: '#C678DD' }} >class </a> <a style={{ color: '#E5C07B' }} > Siddharth </a> &#123; </td>

                        </tr>
                        <tr>
                            <td><a style={{ color: '#636D83' }} >02 </a></td>
                            <td>&emsp; <a style={{ color: '#C678D2' }}> constructor() </a> &#123;</td>


                        </tr>
                        <tr>
                            <td> <a style={{ color: '#636D83' }}>03</a></td>
                            <td> &emsp; &emsp;  <a style={{ color: '#E06C6B' }}> this.name</a>  <a style={{ color: '#56B6C2' }}> = </a><a style={{ color: '#7BC379' }}>'Siddharth Mishra' </a> </td>
                        </tr>
                        <tr>
                            <td><a style={{ color: '#636D83' }}> 04 </a></td>
                            <td> &emsp; &emsp; <a style={{ color: '#E06C6B' }}> this.dayofBirthTimeStamp</a><a style={{ color: '#56B6C2' }}> = </a> <a style={{ color: '#7BC379' }}>'940514700'</a> </td>
                        </tr>
                        <tr>
                            <td><a style={{ color: '#636D83' }}> 05 </a></td>
                            <td> &emsp; &emsp; <a style={{ color: '#E06C6B' }}>this.email</a><a style={{ color: '#56B6C2' }}> = </a> <a style={{ color: '#7BC379' }}>'siddharthm1999@outlook.com'</a></td>
                        </tr>
                        <tr>
                            <td><a style={{ color: '#636D83' }}> 06 </a> </td>
                            <td>  &emsp;  &#125; </td>
                        </tr>
                        <tr>
                            <td><a style={{ color: '#636D83' }}> 07 </a> </td>
                            <td> &emsp; <a style={{ color: '#61AFEF' }}>workExpericence()</a> &#123;</td>
                        </tr>
                        <tr>
                            <td><a style={{ color: '#636D83' }}> 08 </a> </td>
                            <td>&emsp; &emsp;  <a style={{ color: '#C678D2' }}> return</a> &#91; </td>
                        </tr>
                        <tr>
                            <td> <a style={{ color: '#636D83' }}> 09 </a></td>
                            <td> &emsp; &emsp; &emsp; &#123; <a style={{ color: '#7BC379' }}> '2017-2019' <a style={{ color: '#56B6C2' }}> :</a> 'UI Desining'</a> &#125; ,</td>
                        </tr>
                        <tr>
                            <td><a style={{ color: '#636D83' }}>10 </a></td>
                            <td>&emsp; &emsp; &emsp; &#123;  <a style={{ color: '#7BC379' }}>'2018-now'</a> <a style={{ color: '#56B6C2' }}> :</a>  <a style={{ color: '#7BC379' }}> 'ReactJS Developer' </a>&#125; ,  </td>
                        </tr>
                        <tr>
                            <td> <a style={{ color: '#636D83' }}> 11 </a></td>
                            <td>&emsp; &emsp; &emsp; &#123; <a style={{ color: '#7BC379' }}> '2019-now'</a> <a style={{ color: '#56B6C2' }}> :</a> <a style={{ color: '#7BC379' }}>'React-Native Developer' </a> &#125; , </td>
                        </tr>
                        <tr>
                            <td> <a style={{ color: '#636D83' }}> 12 </a></td>
                            <td>&emsp; &emsp; &emsp; &#123; <a style={{ color: '#7BC379' }}> '2020-now'</a> <a style={{ color: '#56B6C2' }}> :</a> <a style={{ color: '#7BC379' }}>'Vue JS Developer' </a> &#125; , </td>
                        </tr>
                        <tr>
                            <td> <a style={{ color: '#636D83' }}> 13 </a></td>
                            <td>&emsp;&emsp; &emsp; &#93; </td>
                        </tr>
                        <tr>
                            <td><a style={{ color: '#636D83' }}> 14 </a></td>
                            <td>&emsp;  &#125; </td>
                        </tr>
                        <tr>
                            <td> <a style={{ color: '#636D83' }}> 15 </a></td>
                            <td>  &emsp; <a style={{ color: '#61AFEF' }}> education()</a> &#123;</td>
                        </tr>
                        <tr>
                            <td><a style={{ color: '#636D83' }}> 16 </a></td>
                            <td>  &emsp; &emsp;  <a style={{ color: '#C678D2' }}> return</a> &#91; </td>
                        </tr>
                        <tr>
                            <td><a style={{ color: '#636D83' }}> 17 </a></td>
                            <td>  &emsp; &emsp; &emsp; &#123; <a style={{ color: '#7BC379' }}> '2014-2015'</a> <a style={{ color: '#56B6C2' }}> :</a> <a style={{ color: '#7BC379' }}>10th Grade - First Class Honours</a> &#125; , </td>
                        </tr>
                        <tr>
                            <td> <a style={{ color: '#636D83' }}> 18 </a></td>
                            <td> &emsp; &emsp; &emsp; &#123; <a style={{ color: '#7BC379' }}>'2016-2017'</a> <a style={{ color: '#56B6C2' }}> :</a> <a style={{ color: '#7BC379' }}>High School - Second Class Honours </a> &#125;,</td>
                        </tr>
                        <tr>
                            <td> <a style={{ color: '#636D83' }}> 19 </a></td>
                            <td>&emsp; &emsp; &emsp; &#123; <a style={{ color: '#7BC379' }}>'2018-'</a> <a style={{ color: '#56B6C2' }}> :</a> <a style={{ color: '#7BC379' }}>University - Bachelor of Technology Computer Science </a>&#125; , </td>
                        </tr>
                        <tr>
                            <td><a style={{ color: '#636D83' }}> 20 </a></td>
                            <td> &emsp;&emsp; &emsp; &#93; </td>
                        </tr>
                        <tr>
                            <td><a style={{ color: '#636D83' }}>21 </a></td>
                            <td>    &emsp;  &#125;   </td>
                        </tr>
                        <tr>
                            <td><a style={{ color: '#636D83' }}>22 </a></td>
                            <td>  &emsp;  <a style={{ color: '#61AFEF' }}> skills()</a> &#123; </td>
                        </tr>
                        <tr>
                            <td><a style={{ color: '#636D83' }}> 23 </a></td>
                            <td>   &emsp; &emsp;  <a style={{ color: '#C678D2' }}> return</a>   </td>
                        </tr>
                        <tr>
                            <td><a style={{ color: '#636D83' }}> 24 </a> </td>
                            <td> &emsp; &emsp; &emsp; &#91;
                            <a style={{ color: '#7BC379' }}>  'HTML5/CSS3/JS' </a>
                                ,
                             <a style={{ color: '#7BC379' }}>  'ReactJs' </a>
                                ,
                                <a style={{ color: '#7BC379' }}>  'VueJs' </a>
                                ,
                               <a style={{ color: '#7BC379' }}>    'Node.js' </a>
                                ,
                                <a style={{ color: '#7BC379' }}>   'Bootstrap/MaterialDesign' </a>
                                ,
                                 <a style={{ color: '#7BC379' }}>   'npm/yarn/chocolatey' </a>
                                ,
                                   <a style={{ color: '#7BC379' }}>     'PWA' </a>
                                ,
                                    <a style={{ color: '#7BC379' }}>     'GIT' </a>
                                ,
                                     <a style={{ color: '#7BC379' }}>      'Firebase' </a>
                                ,
                                       <a style={{ color: '#7BC379' }}>       'MYSQL' </a>
                                <a style={{ color: '#7BC379' }}>        'AfterEffects' </a>
                                ,
                                               <a style={{ color: '#7BC379' }}>       'UI/UX'</a>
                                ,
                                                 <a style={{ color: '#7BC379' }}>        'C' </a>
                                ,
                                                  <a style={{ color: '#7BC379' }}>        'Java8' </a>
                                ,
                                                    <a style={{ color: '#7BC379' }}>         'Python3' </a>
                                &#93;   </td>
                        </tr>
                        <tr>
                            <td><a style={{ color: '#636D83' }}> 25  </a> </td>
                            <td> &emsp;  &emsp;  &#125;  </td>
                        </tr>
                        <tr>
                            <td> <a style={{ color: '#636D83' }}> 26 </a></td>
                            <td>  &#125; </td>
                        </tr>

                    </tbody>

                </div>
            </div>
        </div>
       
    )
}
